import { attachJiraReferralIds } from '../../../jira/jira-search-results/jira-search-results-lists/attach-referral-ids';
import { AttributeType } from '../../../jira/clients/response-types';
import { addQueryParams } from '../../../utils/url-utils';
export const attachIssueSectionQueryParams = (href, searchResult) => {
  const hrefWithReferrals = attachJiraReferralIds(href, {
    searchObjectId: searchResult.id,
    searchContainerId: searchResult.attributes.containerId,
    searchContentType: AttributeType.issue
  });
  return hrefWithReferrals;
};
export const getProjectBoardFilterPlanQueryParams = (href, searchResult) => {
  const containerAttribute = searchResult.attributes['@type'] === AttributeType.board ? {
    searchContainerId: searchResult.attributes.containerId
  } : {};
  const contentTypeAttribute = {
    searchContentType: searchResult.attributes['@type']
  };
  const hrefWithReferrals = attachJiraReferralIds(href, {
    ...contentTypeAttribute,
    ...containerAttribute,
    searchObjectId: searchResult.id
  });
  return hrefWithReferrals;
};
export const useQueryParams = () => {
  return (href, searchResult) => {
    if (searchResult.attributes['@type'] === AttributeType.issue) {
      return attachIssueSectionQueryParams(href, searchResult);
    }
    return getProjectBoardFilterPlanQueryParams(href, searchResult);
  };
};
export const appendQueryParams = (url, searchSessionId) => {
  return addQueryParams(url, {
    searchSessionId
  });
};